<template>
    <transition name="fade">
        <div class="modal fade" id="modalFile" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold">{{attachFile.title}}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="col-12" v-if="attachFile.type=='img'">
                            <div class="attachment-block clearfix text-center">
                                <img :src="attachFile.url" class="img-fluid" alt="Image" style="max-height: 300px!important; min-height:250px!important;">
                            </div>
                        </div>
                        <div class="col-12" v-if="attachFile.type=='pdf'">
                            <object :data="attachFile.url + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="100%">
                                <div class="alert alert-warning2" role="alert">
                                    <p>Your browser isn't supporting embedded pdf files. You can download the file.</p>
                                </div>
                            </object>
                        </div>
                        <div class="col-12" v-if="attachFile.type=='video'">
                            <div class="embed-responsive embed-responsive-16by9">
                                <iframe class="embed-responsive-item" :src="attachFile.url" title="Video" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-primary" @click="closeModalFile"><i class="fas fa-times-circle mr-1"></i>Close</button>
                        <button class="btn btn-outline-primary" @click="downloadFile(attachFile.url, attachFile.name)"><i class="fas fa-download mr-1"></i>Download</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        props: {
            attachFile: Object
        },
        data() {
            return {}
        },

        created() {

        },
        methods: {
            closeModalFile() {
                window.URL.revokeObjectURL(this.attachFile.url);
                $('#modalFile').modal('hide');
                for (let k in this.attachFile) {
                    this.attachFile[k] = null;
                }

                this.$emit('close');
            },
            downloadFile(fileURL, name) {
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', name.slice(name.length - 22));
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(fileURL);
            },
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>